import { render, staticRenderFns } from "./Totp.vue?vue&type=template&id=06dba37d&"
import script from "./Totp.vue?vue&type=script&lang=js&"
export * from "./Totp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports